import { Instance, types, flow } from "mobx-state-tree";
import to from "await-to-js";
import { getUserCouponList } from "@/app/csr-src/apis/voucher/voucher.api";
import { withSetPropAction } from "./helpers/withSetPropAction";

export const CouponItemStoreModel = types.model("CouponItemStore").props({
  areaDesc: types.maybeNull(types.string),
  areaType: types.maybeNull(types.number),
  batchId: types.maybeNull(types.number),
  beginTime: types.maybeNull(types.number),
  beginTimeFormat: types.maybeNull(types.string),
  couponId: types.maybeNull(types.number),
  couponKind: types.maybeNull(types.number),
  couponStyle: types.maybeNull(types.number),
  couponTitle: types.maybeNull(types.string),
  couponType: types.maybeNull(types.number),
  discount: types.maybeNull(types.string),
  discountInfo: types.maybeNull(types.string),
  endTime: types.maybeNull(types.number),
  endTimeFormat: types.maybeNull(types.string),
  limitStr: types.maybeNull(types.string),
  linkStr: types.maybeNull(types.string),
  mixTime: types.maybeNull(types.number),
  platFormInfo: types.maybeNull(types.string),
  platform: types.maybeNull(types.number),
  // platformDetails: types.maybeNull(types.array),
  quota: types.maybeNull(types.string),
  shopId: types.maybeNull(types.number),
  shopName: types.maybeNull(types.string),
  state: types.maybeNull(types.number),
  statusLabel: types.maybeNull(types.string),
  userLabel: types.maybeNull(types.string),
  venderId: types.maybeNull(types.number),
});

export interface ICouponItemStore extends Instance<typeof CouponItemStoreModel> {}

export const VoucherStoreModel = types
  .model("VoucherStore")
  .props({
    loading: types.maybe(types.boolean),
    error: types.maybe(types.string),
    currentPage: types.number,
    pageSize: types.number,
    total: types.number,
    couponData: types.frozen(),
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    getCouponUseData: flow(function* (params) {
      self.loading = true;
      self.error = "";
      self.couponData = [];
      // const requestData = { params };
      const [error, res] = yield to(getUserCouponList(params));
      if (error) {
        self.error = error.message; // 处理错误
      } else {
        // self.couponuseData = res.data.result; // 存储数据
        self.couponData = res.data.data;
        // self.currentPage = res.data.currentPage;
        // self.pageSize = res.data.pageSize;
        self.total = res.data.total;
      }
      self.loading = false;
    }),
    setPageNum(number: number) {
      self.currentPage = number;
    },
  }));

export interface VoucherStoreModel extends Instance<typeof VoucherStoreModel> {}
